import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h3", _mergeProps(_ctx.attributes, { class: "title mb-md-6 col-12" }), _toDisplayString(_ctx.title) + " " + _toDisplayString(_ctx.attributes.index), 17))
}